export default __webpack_public_path__ + "static/media/BB_48.969c311a.png";